/**
 * @file Generated by js-routes 2.3.6. Based on Rails 8.1.3.1 routes of ReactStarterKit::Application.
 * @version ab02d1beb6dc5e05de0ee581ee60154891b7756786381738baff3df2ab5d8121
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                result.push(this.is_not_nullable(value) ||
                    false
                    ? encodeURIComponent(prefix) +
                        "=" +
                        encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : encodeURIComponent(prefix));
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /accounting/expenses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountingExpensesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounting"],[2,[7,"/"],[2,[6,"expenses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accounting/payroll(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountingPayrollIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounting"],[2,[7,"/"],[2,[6,"payroll"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accounting/reports/expenses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountingReportsExpensesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"expenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accounting/reports/service_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountingReportsServiceItemsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"service_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accounting/reports/unbilled(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountingReportsUnbilledPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"unbilled"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accounting/subcontractors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountingSubcontractorsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounting"],[2,[7,"/"],[2,[6,"subcontractors"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cases/:id/activity(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activityCasePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/logs/:id/add_activity(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addActivityCaseLogPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/list_items/add_contact(.:format)
 * @param {any} marketingActivityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addContactMarketingActivityListItemsPath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"list_items"],[2,[7,"/"],[2,[6,"add_contact"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_todos/:id/add_notification(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addNotificationMarketingTodoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_todos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_notification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/activities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminActivitiesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"activities"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/activities/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminActivityPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/activity_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminActivityTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"activity_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/activity_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminActivityTypesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"activity_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/bg_document_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBgDocumentTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bg_document_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/bg_document_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBgDocumentTypesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bg_document_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/client_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminClientTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"client_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/client_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminClientTypesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"client_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompaniesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/contact_roles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminContactRolePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"contact_roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/contact_roles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminContactRolesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"contact_roles"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/contact_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminContactTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"contact_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/contact_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminContactTypesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"contact_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/cron(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCronPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cron"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/cron/housekeeping(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCronHousekeepingPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cron"],[2,[7,"/"],[2,[6,"housekeeping"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/cron/send(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCronSendPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cron"],[2,[7,"/"],[2,[6,"send"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/cron/7y(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCronSevenYearPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cron"],[2,[7,"/"],[2,[6,"7y"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/cron/2y(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCronTwoYearPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cron"],[2,[7,"/"],[2,[6,"2y"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer_document_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCustomerDocumentTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_document_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer_document_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCustomerDocumentTypesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_document_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/default_rates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDefaultRatesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"default_rates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/equipment_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEquipmentTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"equipment_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/equipment_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEquipmentTypesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"equipment_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/evidence_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEvidenceTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"evidence_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/evidence_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEvidenceTypesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"evidence_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/expense_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminExpenseTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"expense_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/expense_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminExpenseTypesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"expense_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/housekeeping(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminHousekeepingIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"housekeeping"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/housekeeping/purge7yr(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminHousekeepingPurge7yrPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"housekeeping"],[2,[7,"/"],[2,[6,"purge7yr"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/investigation_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminInvestigationTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"investigation_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/investigation_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminInvestigationTypesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"investigation_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/log_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminLogTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"log_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/log_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminLogTypesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"log_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/marketing_activity_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMarketingActivityTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"marketing_activity_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/marketing_activity_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMarketingActivityTypesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"marketing_activity_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/marketing_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMarketingCategoriesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"marketing_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/marketing_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMarketingCategoryPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"marketing_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/messages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMessagePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMessagesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/payment_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPaymentTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payment_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/payment_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPaymentTypesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payment_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminReportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/report_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminReportCategoriesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"report_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/report_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminReportCategoryPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"report_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resource_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminResourceTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"resource_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resource_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminResourceTypesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"resource_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/retention(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRetentionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"retention"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/service_item_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminServiceItemTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"service_item_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/service_item_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminServiceItemTypesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"service_item_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/site_admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSiteAdminPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"site_admin"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/subject_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSubjectTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subject_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subject_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSubjectTypesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subject_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/time_zones/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTimeZonePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"time_zones"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/time_zones(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTimeZonesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"time_zones"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/todo_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTodoCategoriesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"todo_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/todo_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTodoCategoryPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"todo_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminVendorTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_type_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminVendorTypeGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_type_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_type_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminVendorTypeGroupsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_type_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminVendorTypesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/expenses/:id/approve(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approveCaseExpensePath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"expenses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/:id/approve(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approveCaseReportPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/time_entries/:id/approve(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approveCaseTimeEntryPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pto_requests/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approvePtoRequestPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pto_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /equipment/:id/assign(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assignEquipmentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"equipment"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /gps_devices/:id/assign(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assignGpsDevicePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gps_devices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /equipment/:id/assignment_history(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assignmentHistoryEquipmentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"equipment"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assignment_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /availability(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const availabilityPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/schedules/availability(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const availabilityCaseSchedulesPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /availability/toggle(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const availabilityTogglePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[6,"toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /employees/:id/block_all_cases(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blockAllCasesEmployeePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"block_all_cases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/:report_id/entries/build_finals(.:format)
 * @param {any} caseId
 * @param {any} reportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildFinalsCaseReportEntriesPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"entries"],[2,[7,"/"],[2,[6,"build_finals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/email_changes/bulk_complete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkCompleteReportsEmailChangesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"email_changes"],[2,[7,"/"],[2,[6,"bulk_complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /calendar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendarPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cases/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const casePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/report_downloads/case_updates_word(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseCaseUpdatesWordPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"report_downloads"],[2,[7,"/"],[2,[6,"case_updates_word"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/contacts/:id(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseContactPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/contacts(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseContactsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/report_downloads/daily_report_pdf/:report_id(.:format)
 * @param {any} caseId
 * @param {any} reportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseDailyReportPdfPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"report_downloads"],[2,[7,"/"],[2,[6,"daily_report_pdf"],[2,[7,"/"],[2,[3,"report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/documents/:id(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseDocumentPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/documents(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseDocumentsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/employees/:id(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseEmployeePath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/employees(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseEmployeesPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"employees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/equipment_assignments/:id(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseEquipmentAssignmentPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"equipment_assignments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/equipment_assignments(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseEquipmentAssignmentsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"equipment_assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/evidence/:id(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseEvidencePath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"evidence"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/evidence(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseEvidenceIndexPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"evidence"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/expenses/:id(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseExpensePath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"expenses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/expenses(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseExpensesPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"expenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/report_downloads/final_report_by_day_word(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseFinalReportByDayWordPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"report_downloads"],[2,[7,"/"],[2,[6,"final_report_by_day_word"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/report_downloads/final_report_by_report_word(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseFinalReportByReportWordPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"report_downloads"],[2,[7,"/"],[2,[6,"final_report_by_report_word"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/final_report_preview(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseFinalReportPreviewPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"final_report_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/final_report_preview_by_report(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseFinalReportPreviewByReportPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"final_report_preview_by_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/gps/:id(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseGpPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"gps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/gps(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseGpsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"gps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/logs/:id(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseLogPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /case_log_reviews/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseLogReviewPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"case_log_reviews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /case_log_reviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseLogReviewsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"case_log_reviews"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/logs(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseLogsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/management/activity(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseManagementActivityPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/management/activity/review(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseManagementActivityReviewPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/photos/:id(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const casePhotoPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/photos(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const casePhotosPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/:id(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseReportPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/:report_id/entries(.:format)
 * @param {any} caseId
 * @param {any} reportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseReportEntriesPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/:report_id/entries/:id(.:format)
 * @param {any} caseId
 * @param {any} reportId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseReportEntryPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseReportsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/schedules/:id(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseSchedulePath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/schedules(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseSchedulesPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/:id(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseSubjectPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/:subject_id/addresses/:id(.:format)
 * @param {any} caseId
 * @param {any} subjectId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseSubjectAddressPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"subject_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"subject_id"],[2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/:subject_id/addresses(.:format)
 * @param {any} caseId
 * @param {any} subjectId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseSubjectAddressesPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"subject_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"subject_id"],[2,[7,"/"],[2,[6,"addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/:subject_id/aliases/:id(.:format)
 * @param {any} caseId
 * @param {any} subjectId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseSubjectAliasPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"subject_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"subject_id"],[2,[7,"/"],[2,[6,"aliases"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/:subject_id/aliases(.:format)
 * @param {any} caseId
 * @param {any} subjectId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseSubjectAliasesPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"subject_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"subject_id"],[2,[7,"/"],[2,[6,"aliases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/:subject_id/contacts/:id(.:format)
 * @param {any} caseId
 * @param {any} subjectId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseSubjectContactPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"subject_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"subject_id"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/:subject_id/contacts(.:format)
 * @param {any} caseId
 * @param {any} subjectId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseSubjectContactsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"subject_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"subject_id"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/:subject_id/criminal_records/:id(.:format)
 * @param {any} caseId
 * @param {any} subjectId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseSubjectCriminalRecordPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"subject_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"subject_id"],[2,[7,"/"],[2,[6,"criminal_records"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/:subject_id/criminal_records(.:format)
 * @param {any} caseId
 * @param {any} subjectId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseSubjectCriminalRecordsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"subject_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"subject_id"],[2,[7,"/"],[2,[6,"criminal_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/:subject_id/education_records/:id(.:format)
 * @param {any} caseId
 * @param {any} subjectId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseSubjectEducationRecordPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"subject_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"subject_id"],[2,[7,"/"],[2,[6,"education_records"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/:subject_id/education_records(.:format)
 * @param {any} caseId
 * @param {any} subjectId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseSubjectEducationRecordsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"subject_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"subject_id"],[2,[7,"/"],[2,[6,"education_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/:subject_id/employment_records/:id(.:format)
 * @param {any} caseId
 * @param {any} subjectId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseSubjectEmploymentRecordPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"subject_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"subject_id"],[2,[7,"/"],[2,[6,"employment_records"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/:subject_id/employment_records(.:format)
 * @param {any} caseId
 * @param {any} subjectId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseSubjectEmploymentRecordsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"subject_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"subject_id"],[2,[7,"/"],[2,[6,"employment_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/:subject_id/photos/:id(.:format)
 * @param {any} caseId
 * @param {any} subjectId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseSubjectPhotoPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"subject_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"subject_id"],[2,[7,"/"],[2,[6,"photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/:subject_id/photos(.:format)
 * @param {any} caseId
 * @param {any} subjectId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseSubjectPhotosPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"subject_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"subject_id"],[2,[7,"/"],[2,[6,"photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/:subject_id/vehicles/:id(.:format)
 * @param {any} caseId
 * @param {any} subjectId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseSubjectVehiclePath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"subject_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"subject_id"],[2,[7,"/"],[2,[6,"vehicles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/:subject_id/vehicles(.:format)
 * @param {any} caseId
 * @param {any} subjectId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseSubjectVehiclesPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"subject_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"subject_id"],[2,[7,"/"],[2,[6,"vehicles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseSubjectsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/report_downloads/supporting_detail_word(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseSupportingDetailWordPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"report_downloads"],[2,[7,"/"],[2,[6,"supporting_detail_word"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/time_entries(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseTimeEntriesPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"time_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/time_entries/:id(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseTimeEntryPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const casesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cases"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cases/management/access(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const casesManagementAccessPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[6,"access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/vendors/check_duplicates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkDuplicatesCompanyVendorsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[6,"check_duplicates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/time_entries/clock_in(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clockInCaseTimeEntriesPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"clock_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/time_entries/clock_out(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clockOutCaseTimeEntriesPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"clock_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:id/close(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const closeCasePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyDocumentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyDocumentsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/images/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyImagePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/phone_book(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyPhoneBookIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"phone_book"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/resources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyResourcePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/resources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyResourcesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"resources"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/signatures/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companySignaturePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"signatures"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/signatures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companySignaturesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"signatures"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/vendors/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyVendorPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/vendors/:vendor_id/contacts/:id(.:format)
 * @param {any} vendorId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyVendorContactPath = /*#__PURE__*/ __jsr.r({"vendor_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[3,"vendor_id"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/vendors/:vendor_id/contacts(.:format)
 * @param {any} vendorId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyVendorContactsPath = /*#__PURE__*/ __jsr.r({"vendor_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[3,"vendor_id"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/vendors/:vendor_id/documents/:id(.:format)
 * @param {any} vendorId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyVendorDocumentPath = /*#__PURE__*/ __jsr.r({"vendor_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[3,"vendor_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/vendors/:vendor_id/documents(.:format)
 * @param {any} vendorId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyVendorDocumentsPath = /*#__PURE__*/ __jsr.r({"vendor_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[3,"vendor_id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/vendors/:vendor_id/logs/:id(.:format)
 * @param {any} vendorId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyVendorLogPath = /*#__PURE__*/ __jsr.r({"vendor_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[3,"vendor_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/vendors/:vendor_id/logs(.:format)
 * @param {any} vendorId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyVendorLogsPath = /*#__PURE__*/ __jsr.r({"vendor_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[3,"vendor_id"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/vendors/:vendor_id/schedules(.:format)
 * @param {any} vendorId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyVendorSchedulesPath = /*#__PURE__*/ __jsr.r({"vendor_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[3,"vendor_id"],[2,[7,"/"],[2,[6,"schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/vendors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyVendorsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"vendors"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/logs/:id/complete(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeCaseLogPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/logs/:id/complete(.:format)
 * @param {any} customerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeCustomerLogPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_todos/:id/complete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeMarketingTodoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_todos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:id/contacts_for_select(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contactsForSelectCustomerPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"contacts_for_select"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /equipment/:id/create_expense(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createExpenseEquipmentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"equipment"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_expense"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /equipment_logs/create_expense(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createExpenseEquipmentLogsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"equipment_logs"],[2,[7,"/"],[2,[6,"create_expense"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/:id/create_prepare_entry(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createPrepareEntryCaseReportPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_prepare_entry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/photos/:id/crop_rotate(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cropRotateCasePhotoPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"crop_rotate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/:subject_id/photos/:id/crop_rotate(.:format)
 * @param {any} caseId
 * @param {any} subjectId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cropRotateCaseSubjectPhotoPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"subject_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"subject_id"],[2,[7,"/"],[2,[6,"photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"crop_rotate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/contacts/:id(.:format)
 * @param {any} customerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerContactPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/contacts(.:format)
 * @param {any} customerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerContactsPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/documents/:id(.:format)
 * @param {any} customerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerDocumentPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/documents(.:format)
 * @param {any} customerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerDocumentsPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/emails(.:format)
 * @param {any} customerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerEmailsPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/expenses/:id(.:format)
 * @param {any} customerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerExpensePath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"expenses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/expenses(.:format)
 * @param {any} customerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerExpensesPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"expenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/locations/:id(.:format)
 * @param {any} customerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerLocationPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/locations(.:format)
 * @param {any} customerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerLocationsPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/logs/:id(.:format)
 * @param {any} customerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerLogPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/logs(.:format)
 * @param {any} customerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerLogsPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/marketing_events(.:format)
 * @param {any} customerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerMarketingEventsPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"marketing_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/schedules/:id(.:format)
 * @param {any} customerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerSchedulePath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/schedules(.:format)
 * @param {any} customerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerSchedulesPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/time_entries(.:format)
 * @param {any} customerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerTimeEntriesPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"time_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/time_entries/:id(.:format)
 * @param {any} customerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerTimeEntryPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /equipment/:id/deactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deactivateEquipmentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"equipment"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/resources/:id/delete_file(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteFileCompanyResourcePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pto_requests/:id/deny(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const denyPtoRequestPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pto_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deny"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/logs/:id/destroy_activity(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyActivityCaseLogPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy_activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/activities/destroy_all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyAllAdminActivitiesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[6,"destroy_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /equipment/:id/assignments/:assignment_id(.:format)
 * @param {any} id
 * @param {any} assignmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyAssignmentEquipmentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"assignment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"equipment"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assignments"],[2,[7,"/"],[2,[3,"assignment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/destroy_read(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyReadNotificationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"destroy_read"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accounting/payroll/detail(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detailAccountingPayrollIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounting"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"detail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/billing_reports/detail(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detailCaseBillingReportsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"billing_reports"],[2,[7,"/"],[2,[6,"detail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/documents/:id/download(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadCaseDocumentPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/photos/:id/download(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadCasePhotoPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/documents/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadCompanyDocumentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/resources/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadCompanyResourcePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/vendors/:vendor_id/documents/:id/download(.:format)
 * @param {any} vendorId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadCompanyVendorDocumentPath = /*#__PURE__*/ __jsr.r({"vendor_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[3,"vendor_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/documents/:id/download(.:format)
 * @param {any} customerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadCustomerDocumentPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/documents/:id/download(.:format)
 * @param {any} marketingActivityId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadMarketingActivityDocumentPath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/activity_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminActivityTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"activity_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/bg_document_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminBgDocumentTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bg_document_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/client_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminClientTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"client_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCompanyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/contact_roles/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminContactRolePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"contact_roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/contact_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminContactTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"contact_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer_document_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCustomerDocumentTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_document_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/equipment_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminEquipmentTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"equipment_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/evidence_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminEvidenceTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"evidence_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/expense_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminExpenseTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"expense_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/investigation_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminInvestigationTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"investigation_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/log_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminLogTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"log_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/marketing_activity_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminMarketingActivityTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"marketing_activity_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/marketing_categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminMarketingCategoryPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"marketing_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/messages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminMessagePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/payment_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminPaymentTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payment_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/reports/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminReportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/report_categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminReportCategoryPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"report_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resource_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminResourceTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"resource_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/service_item_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminServiceItemTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"service_item_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subject_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminSubjectTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subject_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/time_zones/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminTimeZonePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"time_zones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/todo_categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminTodoCategoryPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"todo_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminVendorTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_type_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminVendorTypeGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_type_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /equipment/:id/edit_assignment/:assignment_id(.:format)
 * @param {any} id
 * @param {any} assignmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAssignmentEquipmentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"assignment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"equipment"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_assignment"],[2,[7,"/"],[2,[3,"assignment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCasePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/contacts/:id/edit(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCaseContactPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/documents/:id/edit(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCaseDocumentPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/employees/:id/edit(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCaseEmployeePath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/equipment_assignments/:id/edit(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCaseEquipmentAssignmentPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"equipment_assignments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/evidence/:id/edit(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCaseEvidencePath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"evidence"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/expenses/:id/edit(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCaseExpensePath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"expenses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/gps/:id/edit(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCaseGpPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"gps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/logs/:id/edit(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCaseLogPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/photos/:id/edit(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCasePhotoPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/:id/edit(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCaseReportPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/:report_id/entries/:id/edit(.:format)
 * @param {any} caseId
 * @param {any} reportId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCaseReportEntryPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/schedules/:id/edit(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCaseSchedulePath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/:id/edit(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCaseSubjectPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/:subject_id/photos/:id/edit(.:format)
 * @param {any} caseId
 * @param {any} subjectId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCaseSubjectPhotoPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"subject_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"subject_id"],[2,[7,"/"],[2,[6,"photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/time_entries/:id/edit(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCaseTimeEntryPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/documents/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCompanyDocumentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/resources/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCompanyResourcePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/signatures/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCompanySignaturePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"signatures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/vendors/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCompanyVendorPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/vendors/:vendor_id/contacts/:id/edit(.:format)
 * @param {any} vendorId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCompanyVendorContactPath = /*#__PURE__*/ __jsr.r({"vendor_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[3,"vendor_id"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/vendors/:vendor_id/documents/:id/edit(.:format)
 * @param {any} vendorId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCompanyVendorDocumentPath = /*#__PURE__*/ __jsr.r({"vendor_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[3,"vendor_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/vendors/:vendor_id/logs/:id/edit(.:format)
 * @param {any} vendorId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCompanyVendorLogPath = /*#__PURE__*/ __jsr.r({"vendor_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[3,"vendor_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCustomerPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/contacts/:id/edit(.:format)
 * @param {any} customerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCustomerContactPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/documents/:id/edit(.:format)
 * @param {any} customerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCustomerDocumentPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/locations/:id/edit(.:format)
 * @param {any} customerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCustomerLocationPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/logs/:id/edit(.:format)
 * @param {any} customerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCustomerLogPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/schedules/:id/edit(.:format)
 * @param {any} customerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCustomerSchedulePath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /employees/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editEmployeePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /equipment/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editEquipmentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"equipment"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /equipment_logs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editEquipmentLogPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"equipment_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /gps_devices/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGpsDevicePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gps_devices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /identity/password_reset/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editIdentityPasswordResetPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"password_reset"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editMarketingActivityPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/documents/:id/edit(.:format)
 * @param {any} marketingActivityId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editMarketingActivityDocumentPath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/employees/:id/edit(.:format)
 * @param {any} marketingActivityId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editMarketingActivityEmployeePath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/expenses/:id/edit(.:format)
 * @param {any} marketingActivityId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editMarketingActivityExpensePath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"expenses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/list_items/:id/edit(.:format)
 * @param {any} marketingActivityId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editMarketingActivityListItemPath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"list_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/time_entries/:id/edit(.:format)
 * @param {any} marketingActivityId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editMarketingActivityTimeEntryPath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_todos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editMarketingTodoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_todos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_todos/:marketing_todo_id/replies/:id/edit(.:format)
 * @param {any} marketingTodoId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editMarketingTodoReplyPath = /*#__PURE__*/ __jsr.r({"marketing_todo_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_todos"],[2,[7,"/"],[2,[3,"marketing_todo_id"],[2,[7,"/"],[2,[6,"replies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pto_credits/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPtoCreditPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pto_credits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pto_requests/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPtoRequestPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pto_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /employees/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const employeePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /employees/:employee_id/logs/:id(.:format)
 * @param {any} employeeId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const employeeLogPath = /*#__PURE__*/ __jsr.r({"employee_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"employee_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /employees/:employee_id/logs(.:format)
 * @param {any} employeeId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const employeeLogsPath = /*#__PURE__*/ __jsr.r({"employee_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"employee_id"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /employees(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const employeesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"employees"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /employees/activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const employeesActivityPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /employees/activity/equipment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const employeesActivityEquipmentPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[2,[6,"equipment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /employees/activity/evidence(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const employeesActivityEvidencePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[2,[6,"evidence"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /employees/activity/unsubmitted(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const employeesActivityUnsubmittedPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[2,[6,"unsubmitted"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /employees/logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const employeesLogsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /employees/reports/access-exceptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const employeesReportsAccessExceptionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"access-exceptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /employees/reports/service-items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const employeesReportsServiceItemsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"service-items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /equipment/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipmentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"equipment"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /equipment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipmentIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"equipment"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /equipment_logs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipmentLogPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"equipment_logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /equipment_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipmentLogsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"equipment_logs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /gps_devices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gpsDevicePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gps_devices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /gps_devices/:gps_device_id/assignments(.:format)
 * @param {any} gpsDeviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gpsDeviceAssignmentsPath = /*#__PURE__*/ __jsr.r({"gps_device_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gps_devices"],[2,[7,"/"],[2,[3,"gps_device_id"],[2,[7,"/"],[2,[6,"assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /gps_devices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gpsDevicesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"gps_devices"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /employees/:id/grant_all_cases(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const grantAllCasesEmployeePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"grant_all_cases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accounting/expenses/history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const historyAccountingExpensesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounting"],[2,[7,"/"],[2,[6,"expenses"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accounting/payroll/history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const historyAccountingPayrollIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounting"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /equipment/:id/history(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const historyEquipmentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"equipment"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /identity/email_verification(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const identityEmailVerificationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"email_verification"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /identity/password_reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const identityPasswordResetPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"password_reset"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customers/:id/locations_for_select(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationsForSelectCustomerPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"locations_for_select"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/billing_reports/mark_all_expenses_billed(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markAllExpensesBilledCaseBillingReportsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"billing_reports"],[2,[7,"/"],[2,[6,"mark_all_expenses_billed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/mark_all_read(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markAllReadNotificationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"mark_all_read"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/billing_reports/mark_all_time_billed(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markAllTimeBilledCaseBillingReportsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"billing_reports"],[2,[7,"/"],[2,[6,"mark_all_time_billed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/billing_reports/mark_all_tscm_billed(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markAllTscmBilledCaseBillingReportsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"billing_reports"],[2,[7,"/"],[2,[6,"mark_all_tscm_billed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/:id/mark_as_read(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markAsReadNotificationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/billing_reports/mark_expense_billed(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markExpenseBilledCaseBillingReportsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"billing_reports"],[2,[7,"/"],[2,[6,"mark_expense_billed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/time_entries/:id/mark_mileage_paid(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markMileagePaidCaseTimeEntryPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_mileage_paid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accounting/expenses/mark_paid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markPaidAccountingExpensesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounting"],[2,[7,"/"],[2,[6,"expenses"],[2,[7,"/"],[2,[6,"mark_paid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accounting/payroll/mark_paid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markPaidAccountingPayrollIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounting"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"mark_paid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accounting/subcontractors/mark_paid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markPaidAccountingSubcontractorsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounting"],[2,[7,"/"],[2,[6,"subcontractors"],[2,[7,"/"],[2,[6,"mark_paid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/:id/mark_prepared(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markPreparedCaseReportPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_prepared"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/billing_reports/mark_time_billed(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markTimeBilledCaseBillingReportsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"billing_reports"],[2,[7,"/"],[2,[6,"mark_time_billed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/time_entries/:id/mark_time_paid(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markTimePaidCaseTimeEntryPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_time_paid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/billing_reports/mark_tscm_billed(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markTscmBilledCaseBillingReportsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"billing_reports"],[2,[7,"/"],[2,[6,"mark_tscm_billed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketingActivitiesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketingActivityPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/documents/:id(.:format)
 * @param {any} marketingActivityId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketingActivityDocumentPath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/documents(.:format)
 * @param {any} marketingActivityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketingActivityDocumentsPath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/employees/:id(.:format)
 * @param {any} marketingActivityId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketingActivityEmployeePath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/employees(.:format)
 * @param {any} marketingActivityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketingActivityEmployeesPath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"employees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/expenses/:id(.:format)
 * @param {any} marketingActivityId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketingActivityExpensePath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"expenses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/expenses(.:format)
 * @param {any} marketingActivityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketingActivityExpensesPath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"expenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/list_items/:id(.:format)
 * @param {any} marketingActivityId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketingActivityListItemPath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"list_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/list_items(.:format)
 * @param {any} marketingActivityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketingActivityListItemsPath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"list_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/time_entries(.:format)
 * @param {any} marketingActivityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketingActivityTimeEntriesPath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"time_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/time_entries/:id(.:format)
 * @param {any} marketingActivityId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketingActivityTimeEntryPath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_todos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketingTodoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_todos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /marketing_todos/:marketing_todo_id/replies(.:format)
 * @param {any} marketingTodoId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketingTodoRepliesPath = /*#__PURE__*/ __jsr.r({"marketing_todo_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_todos"],[2,[7,"/"],[2,[3,"marketing_todo_id"],[2,[7,"/"],[2,[6,"replies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_todos/:marketing_todo_id/replies/:id(.:format)
 * @param {any} marketingTodoId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketingTodoReplyPath = /*#__PURE__*/ __jsr.r({"marketing_todo_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_todos"],[2,[7,"/"],[2,[3,"marketing_todo_id"],[2,[7,"/"],[2,[6,"replies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_todos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketingTodosPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"marketing_todos"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/:id/member_submit(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const memberSubmitCaseReportPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"member_submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/activity_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminActivityTypePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"activity_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/bg_document_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminBgDocumentTypePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bg_document_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/client_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminClientTypePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"client_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCompanyPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/contact_roles/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminContactRolePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"contact_roles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/contact_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminContactTypePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"contact_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer_document_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCustomerDocumentTypePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_document_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/equipment_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminEquipmentTypePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"equipment_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/evidence_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminEvidenceTypePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"evidence_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/expense_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminExpenseTypePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"expense_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/investigation_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminInvestigationTypePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"investigation_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/log_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminLogTypePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"log_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/marketing_activity_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminMarketingActivityTypePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"marketing_activity_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/marketing_categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminMarketingCategoryPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"marketing_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/messages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminMessagePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/payment_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminPaymentTypePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payment_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/reports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminReportPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/report_categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminReportCategoryPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"report_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resource_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminResourceTypePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"resource_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/service_item_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminServiceItemTypePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"service_item_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subject_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminSubjectTypePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subject_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/time_zones/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminTimeZonePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"time_zones"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/todo_categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminTodoCategoryPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"todo_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminVendorTypePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_type_groups/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminVendorTypeGroupPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_type_groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCasePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/contacts/new(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCaseContactPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/documents/new(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCaseDocumentPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/employees/new(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCaseEmployeePath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/equipment_assignments/new(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCaseEquipmentAssignmentPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"equipment_assignments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/evidence/new(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCaseEvidencePath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"evidence"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/expenses/new(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCaseExpensePath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"expenses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/gps/new(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCaseGpPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"gps"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/logs/new(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCaseLogPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/photos/new(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCasePhotoPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/new(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCaseReportPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/:report_id/entries/new(.:format)
 * @param {any} caseId
 * @param {any} reportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCaseReportEntryPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"entries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/schedules/new(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCaseSchedulePath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/new(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCaseSubjectPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/time_entries/new(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCaseTimeEntryPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCompanyDocumentPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/resources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCompanyResourcePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/signatures/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCompanySignaturePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"signatures"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/vendors/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCompanyVendorPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/vendors/:vendor_id/contacts/new(.:format)
 * @param {any} vendorId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCompanyVendorContactPath = /*#__PURE__*/ __jsr.r({"vendor_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[3,"vendor_id"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/vendors/:vendor_id/documents/new(.:format)
 * @param {any} vendorId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCompanyVendorDocumentPath = /*#__PURE__*/ __jsr.r({"vendor_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[3,"vendor_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/vendors/:vendor_id/logs/new(.:format)
 * @param {any} vendorId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCompanyVendorLogPath = /*#__PURE__*/ __jsr.r({"vendor_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[3,"vendor_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomerPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/contacts/new(.:format)
 * @param {any} customerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomerContactPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/documents/new(.:format)
 * @param {any} customerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomerDocumentPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/expenses/new(.:format)
 * @param {any} customerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomerExpensePath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"expenses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/locations/new(.:format)
 * @param {any} customerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomerLocationPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/logs/new(.:format)
 * @param {any} customerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomerLogPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/schedules/new(.:format)
 * @param {any} customerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomerSchedulePath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/time_entries/new(.:format)
 * @param {any} customerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomerTimeEntryPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /employees/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newEmployeePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /equipment/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newEquipmentPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"equipment"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /equipment_logs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newEquipmentLogPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"equipment_logs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /equipment_logs/new_expense(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newExpenseEquipmentLogsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"equipment_logs"],[2,[7,"/"],[2,[6,"new_expense"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /gps_devices/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGpsDevicePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"gps_devices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newMarketingActivityPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/documents/new(.:format)
 * @param {any} marketingActivityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newMarketingActivityDocumentPath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/employees/new(.:format)
 * @param {any} marketingActivityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newMarketingActivityEmployeePath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/expenses/new(.:format)
 * @param {any} marketingActivityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newMarketingActivityExpensePath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"expenses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/list_items/new(.:format)
 * @param {any} marketingActivityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newMarketingActivityListItemPath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"list_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/time_entries/new(.:format)
 * @param {any} marketingActivityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newMarketingActivityTimeEntryPath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_todos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newMarketingTodoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"marketing_todos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /marketing_todos/:marketing_todo_id/replies/new(.:format)
 * @param {any} marketingTodoId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newMarketingTodoReplyPath = /*#__PURE__*/ __jsr.r({"marketing_todo_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_todos"],[2,[7,"/"],[2,[3,"marketing_todo_id"],[2,[7,"/"],[2,[6,"replies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pto_credits/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPtoCreditPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pto_credits"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pto_requests/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPtoRequestPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pto_requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRailsConductorInboundEmailPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRailsConductorInboundEmailSourcePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notificationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notificationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /employees/permission_definitions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const permissionDefinitionsEmployeesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"permission_definitions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /employees/permissions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const permissionsEmployeesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/:id/prepare(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prepareCaseReportPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"prepare"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/housekeeping/:id/preview_restricted(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewRestrictedAdminHousekeepingPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"housekeeping"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview_restricted"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/housekeeping/:id/preview_sensitive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewSensitiveAdminHousekeepingPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"housekeeping"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview_sensitive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pto_credits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ptoCreditPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pto_credits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pto_credits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ptoCreditsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pto_credits"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /pto_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ptoRequestPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pto_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pto_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ptoRequestsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pto_requests"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/housekeeping/:id/purge_restricted(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purgeRestrictedAdminHousekeepingPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"housekeeping"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"purge_restricted"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/housekeeping/:id/purge_sensitive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purgeSensitiveAdminHousekeepingPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"housekeeping"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"purge_sensitive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/list_items/quick_add(.:format)
 * @param {any} marketingActivityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quickAddMarketingActivityListItemsPath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"list_items"],[2,[7,"/"],[2,[6,"quick_add"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationPath = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationProxyPath = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inboundEmailId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailIncineratePath = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inboundEmailId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailReroutePath = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailSourcesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDirectUploadsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encodedKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDiskServicePath = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsHealthCheckPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMailgunInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMandrillInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMandrillInboundHealthCheckPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsPostmarkInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsRelayInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsSendgridInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobPath = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobProxyPath = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/evidence/:id/rate(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rateCaseEvidencePath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"evidence"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /equipment/:id/reactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reactivateEquipmentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"equipment"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/expenses/:id/receipt(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receiptCaseExpensePath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"expenses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/expenses/:id/receipt(.:format)
 * @param {any} customerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receiptCustomerExpensePath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"expenses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /equipment_logs/:id/receipt(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receiptEquipmentLogPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"equipment_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/expenses/:id/receipt(.:format)
 * @param {any} marketingActivityId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receiptMarketingActivityExpensePath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"expenses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/evidence/:id/receive(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receiveCaseEvidencePath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"evidence"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"receive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/referral_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referralSearchCustomersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"referral_search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/reports/referrals(.:format)
 * @param {any} customerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referralsCustomerReportsPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"referrals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/expenses/:id/reject(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejectCaseExpensePath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"expenses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/:id/reject(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejectCaseReportPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/time_entries/:id/reject(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejectCaseTimeEntryPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/:id/reject_member(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejectMemberCaseReportPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject_member"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/gps/:id/remove(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeCaseGpPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"gps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_todos/:id/remove_notification(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeNotificationMarketingTodoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_todos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_notification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/expenses/:id/remove_receipt(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeReceiptCaseExpensePath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"expenses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /equipment_logs/:id/remove_receipt(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeReceiptEquipmentLogPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"equipment_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/expenses/:id/remove_receipt(.:format)
 * @param {any} marketingActivityId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeReceiptMarketingActivityExpensePath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"expenses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /equipment_logs/:id/replace_receipt(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const replaceReceiptEquipmentLogPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"equipment_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"replace_receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/case_activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsCaseActivityIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"case_activity"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/client_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsClientLogsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"client_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/eight_twenty(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsEightTwentyIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"eight_twenty"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/email_changes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsEmailChangesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"email_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/employee_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsEmployeeLogsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"employee_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/expenses_by_type(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsExpensesByTypeIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"expenses_by_type"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/incident_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsIncidentReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"incident_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/incomplete_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsIncompleteReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"incomplete_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/marketing/client_trends(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsMarketingClientTrendsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"client_trends"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/marketing/mailing_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsMarketingMailingListsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"mailing_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/marketing/new_cases(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsMarketingNewCasesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"new_cases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/marketing/referral_mailing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsMarketingReferralMailingIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"referral_mailing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/pending_approval(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsPendingApprovalIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"pending_approval"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/pending_preparation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsPendingPreparationIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"pending_preparation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/referrals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsReferralsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"referrals"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/referrals_by_contact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsReferralsByContactIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"referrals_by_contact"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/ytd_cases(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsYtdCasesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"ytd_cases"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /employees/:id/reset_password(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetPasswordEmployeePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /equipment/:id/return_assignment/:assignment_id(.:format)
 * @param {any} id
 * @param {any} assignmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const returnAssignmentEquipmentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"assignment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"equipment"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"return_assignment"],[2,[7,"/"],[2,[3,"assignment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/:id/review(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewCaseReportPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /review/time-expenses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewTimeExpensesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"time-expenses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /review/time-expenses/review(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewTimeExpensesReviewPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"time-expenses"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/:report_id/entries/:id/revise(.:format)
 * @param {any} caseId
 * @param {any} reportId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviseCaseReportEntryPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revise"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rootPath = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /accounting/payroll/sample(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sampleAccountingPayrollIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounting"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"sample"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /customers/search_for_select(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchForSelectCustomersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"search_for_select"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/select_final_reports(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const selectFinalReportsCaseReportsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"select_final_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/site_admin/send_test_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendTestEmailAdminSiteAdminPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"site_admin"],[2,[7,"/"],[2,[6,"send_test_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/site_admin/send_test_notification(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendTestNotificationAdminSiteAdminPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"site_admin"],[2,[7,"/"],[2,[6,"send_test_notification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sessions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sessionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsEmailPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsProfilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsSessionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signInPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/subjects/sort(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sortCaseSubjectsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[6,"sort"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/:id/submit_all_members(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submitAllMembersCaseReportPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit_all_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/expenses/:id/submit(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submitCaseExpensePath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"expenses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/:id/submit(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submitCaseReportPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/time_entries/:id/submit(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submitCaseTimeEntryPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/expenses/:id/submit(.:format)
 * @param {any} marketingActivityId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submitMarketingActivityExpensePath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"expenses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_activities/:marketing_activity_id/time_entries/:id/submit(.:format)
 * @param {any} marketingActivityId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submitMarketingActivityTimeEntryPath = /*#__PURE__*/ __jsr.r({"marketing_activity_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_activities"],[2,[7,"/"],[2,[3,"marketing_activity_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accounting/payroll/summary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summaryAccountingPayrollIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounting"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/billing_reports/supporting_detail(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const supportingDetailCaseBillingReportsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"billing_reports"],[2,[7,"/"],[2,[6,"supporting_detail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/download/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taskDownloadPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/sample(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taskNotificationSamplePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"sample"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /team(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teamPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /team/activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teamActivityPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /team/logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teamLogsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /team/payments/detail(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teamPaymentDetailPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"detail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /team/payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teamPaymentsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /team/payroll(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teamPayrollPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"payroll"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /team/payroll/detail(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teamPayrollDetailPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"detail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /team/reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teamReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /team/schedule(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teamSchedulePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /team/signature(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teamSignaturePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"signature"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /team/tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teamTasksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_id/reports/time(.:format)
 * @param {any} customerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timeCustomerReportsPath = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"time"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/:report_id/entries/:id/toggle_also(.:format)
 * @param {any} caseId
 * @param {any} reportId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleAlsoCaseReportEntryPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_also"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/:id/toggle_final_inclusion(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleFinalInclusionCaseReportPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_final_inclusion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /gps_devices/:id/unassign(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unassignGpsDevicePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gps_devices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unassign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/billing_reports/unbill_expense(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unbillExpenseCaseBillingReportsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"billing_reports"],[2,[7,"/"],[2,[6,"unbill_expense"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/billing_reports/unbill_time(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unbillTimeCaseBillingReportsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"billing_reports"],[2,[7,"/"],[2,[6,"unbill_time"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/update_final_reports(.:format)
 * @param {any} caseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateFinalReportsCaseReportsPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"update_final_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:case_id/reports/:id/update_prepare_entry(.:format)
 * @param {any} caseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePrepareEntryCaseReportPath = /*#__PURE__*/ __jsr.r({"case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"case_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_prepare_entry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encodedToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateRailsDiskServicePath = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /accounting/payroll/week_detail(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weekDetailAccountingPayrollIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounting"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"week_detail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cases/:id/worksheet(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const worksheetCasePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"worksheet"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

